import {
  U21AlertSearch,
  U21AlertSearchProps,
} from 'app/shared/u21-ui/components/dashboard/U21AlertSearch';

export const CasesAlertSearch = (props: U21AlertSearchProps<false>) => {
  return <U21AlertSearch {...props} clearable={false} />;
};
